"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUploadcareImageSizeValid = isUploadcareImageSizeValid;
var _constants = require("../constants.cjs");
function isUploadcareImageSizeValid(uploadcareImage) {
  var originalHeight = uploadcareImage.originalHeight,
    originalWidth = uploadcareImage.originalWidth;
  return originalWidth * originalHeight <= _constants.UPLOADCARE_IMAGE_SIZE_LIMIT;
}